
<template>
    
        <mars-view id="selected-bottom" class="selected-bottom" :class="{'compatible-safarea': compatibleSafarea}"><mars-view v-if="hostedContentFrom === 'pgc_lvlin_aigc'" class="reserve-1 reserve-3" :style="{'width': '100%'}" @click.native="aigcArticleClick"><mars-image class="reserve-telephone-icon" src="https://lvlin-base.cdn.bcebos.com/law/pages/images/icon-telephone.png"></mars-image><mars-view class="reserve-font" :class="'reserve-font-' + fontSizeSetting">立即咨询专业律师</mars-view></mars-view><template v-else><mars-view class="reserve-box"><mars-view class="reserve-1" @click.native="turnMessage('form')"><mars-image class="reserve-icon-left" src="https://lvlin-base.bj.bcebos.com/law/pages/struct/red-telephone.png"></mars-image><mars-view class="reserve-font reserve-left" :class="'reserve-font-' + fontSizeSetting">0元预约{{ isAreaLabel ? lawyerGroupName : '专业律师' }}</mars-view></mars-view><mars-view class="reserve-1 reserve-3" @click.native="turnMessage('bot')"><mars-view class="sweep-animation"></mars-view><mars-image class="reserve-icon-right" src="https://lvlin-base.bj.bcebos.com/law/pages/struct/white-consult.png"></mars-image><mars-view class="reserve-font" :class="'reserve-font-' + fontSizeSetting">免费在线咨询</mars-view></mars-view></mars-view></template></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan */

import { sendUbcShowLog } from '../../../static/utils/ubcMethods';
import log from '../../../static/utils/ubcLog';
import { request } from '../../../static/utils/request';
import { reqPathTo } from '../../../static/utils/env';
import { getUrlQuery } from '../../../static/utils/core';
import { act } from '../../../static/utils/navigate.js';
export default {
  name: 'SelectedBottomBar',
  props: {
    consultCount: {
      type: Number,
      default: 0
    },
    consultUrl: {
      type: String,
      default: ''
    },
    // 底部是否需要添加iphoneX底部安全区域
    compatibleSafarea: {
      type: Boolean,
      default: true
    },
    lawyerGroupName: {
      type: String,
      default: ''
    },
    from: {
      type: String,
      default: ''
    },
    pageName: {
      type: String,
      default: ''
    },
    isLoftBottom: {
      type: Boolean,
      default: false
    },
    bottomFixedNum: {
      type: Number,
      default: 0
    },
    cityName: {
      type: String,
      default: ''
    },
    hostedContentFrom: {
      type: String,
      default: ''
    },
    fontSizeSetting: {
      type: Number,
      default: 0
    },
    // 对应cpc创新样式广告位置
    pos: {
      type: String,
      default: 'lvlin_qa1'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    const {
      userIP,
      baiduID
    } = getUrlQuery() || {};
    return {
      canIUseLoginButton: getApp().globalData.canIUseLoginButton,
      platform: getApp().globalData.platform,
      isH5: "h5" === 'h5',
      userIP,
      baiduID,
      finalUrl: '',
      isAd: true,
      traceId: '',
      eid: '',
      adData: {}
    };
  },
  mounted() {
    sendUbcShowLog({
      page: 'qalandpage/selected',
      value: 'buttom-button-exp-show'
    });
    let {
      zhishiSids
    } = getApp().globalData || {};
    const sids = zhishiSids.split('-');
    let sidsObj = {};
    sids && sids.forEach(item => {
      const [key, value] = item.split('_');
      sidsObj[key] = value;
    });
    log.send && log.send({
      serverId: 17260,
      area: 'pref_guide',
      action: 'show',
      optype: 'bot_opinion_review_form'
    });
    this.isTest && this.getAdsLawyer();
  },
  computed: {
    isAreaLabel() {
      return this.lawyerGroupName !== '专业律师';
    },
    // 底部按钮跳广告实验(小程序)
    isTest() {
      getApp().globalData.lawExpTags || {};
      return "h5" === 'swan';
    }
  },
  methods: {
    // 跳转留言
    turnMessage(type) {
      if (this.isTest && type === 'bot' && this.adData.targetUrl) {
        this.handleAdClick();
      } else {
        this.$emit('turnReserve', type);
      }
      log.send && log.send({
        serverId: type === 'bot' ? 17260 : 16206,
        area: 'pref_guide',
        action: 'click',
        optype: type === 'bot' ? this.isH5 ? 'bot_opinion_review_form_H5' : 'bot_opinion_review_form' : this.from
      });
    },
    aigcArticleClick() {
      this.$emit('aigcArticleClick');
    },
    getAdsLawyer() {
      const params = {
        device: 'wise',
        pos: this.pos,
        title: this.title && encodeURIComponent(this.title) || '',
        userIP: this.userIP,
        baiduID: this.baiduID
      };
      request({
        url: reqPathTo('rec', {}, '', 'income/cpc/ad'),
        data: params,
        method: 'post',
        loginNeeded: false,
        needBduss: true,
        header: {
          'content-type': 'application/json'
        }
      }).then(res => {
        const data = res.data;
        if (+data.status === 0) {
          const adData = data.data || {};
          // 获取traceId，为广告请求id，记录打点
          this.traceId = adData.trace_id || '';
          this.eid = adData.eids || '';
          const list = adData.list || [];
          log.addKey && log.addKey({
            serverId: 19227,
            traceId: this.traceId,
            ads_lawyer_eid: this.eid
          });
          // 只取1条数据
          const firstThreeItem = list.slice(0, 1) && list.slice(0, 1)[0];
          if (firstThreeItem) {
            this.adData = {
              targetUrl: firstThreeItem.target_url,
              fclickUrl: firstThreeItem.fclick_url,
              searchId: firstThreeItem.searchid
            };
            this.finalUrl = firstThreeItem.target_url;
          }
          firstThreeItem && this.$nextTick(() => {
            // 非真实曝光、凤巢侧统计展现检索量
            log.send && log.send({
              area: 'ads-eshow',
              action: 'show',
              adNum: 1
            });
            // 业务方真实曝光
            setTimeout(() => {
              log.send && log.send({
                area: 'ads-lawyer',
                action: 'show',
                adNum: 1
              });
              log.send && log.send({
                area: 'ads-lawyer-item-show',
                action: 'show',
                searchId: firstThreeItem.searchId
              });
            }, 500);
          });
        }
      }).catch(() => {
        this.$api.showToast({
          title: '获取数据失败',
          icon: 'none'
        });
      });
    },
    handleAdClick() {
      log.send && log.send({
        area: 'ads-lawyer-item-click',
        action: 'click',
        searchId: this.adData.searchId,
        ads_lawyer_eid: this.eid,
        traceId: this.traceId
      });
      // 加个延时防止请求被冲掉
      setTimeout(() => {
        act({
          target: this.finalUrl,
          type: 'webview'
        });
      }, 300);
    }
  }
};
</script>

<style scoped>
.selected-bottom {
  width: 100vw;
  background-color: #fff;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  /* swan ok; h5 no ok */
  /* h5 ok; swan no ok */
}
.selected-bottom .big-font {
  font-family: PingFang SC;
  font-size: 18px;
  line-height: 1;
  font-weight: 700;
}
.selected-bottom .reserve-box {
  width: 100vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.selected-bottom .reserve-1 {
  width: 50%;
  height: 0.55rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(90deg, rgba(253, 80, 62, 0.1) 0.55%, rgba(255, 64, 96, 0.1) 99.92%);
}
.selected-bottom .reserve-1 .reserve-icon-1 {
  width: 30vw;
  height: 4.8vw;
}
.selected-bottom .reserve-1 .reserve-telephone-icon {
  width: 4.03vw;
  height: 4.03vw;
}
.selected-bottom .reserve-1 .reserve-icon-left,
.selected-bottom .reserve-1 .reserve-icon-right {
  width: 4.5vw;
  height: 4.5vw;
}
.selected-bottom .reserve-1 .reserve-font {
  margin-left: 0.89vw;
  font-family: PingFang SC;
  font-size: 4.11vw;
  font-weight: 500;
  line-height: 1.06;
  letter-spacing: 0px;
  text-align: center;
  color: #ffffff;
}
.selected-bottom .reserve-1 .reserve-left {
  color: #fd4456;
}
.selected-bottom .reserve-1 .sweep-animation {
  visibility: hidden;
  position: absolute;
  width: 20.85vw;
  height: 16.34vw;
  z-index: 0;
  background-image: url("https://lvlin-base.cdn.bcebos.com/law/pages/images/btn-ani.png");
  background-size: contain;
  left: 0;
  -webkit-animation: rightSlide 1s linear;
  animation: rightSlide 1s linear;
  animation-delay: 5s;
  animation-fill-mode: forwards;
}
@keyframes rightSlide {
  0% {
    visibility: visible;
    -webkit-transform: translate3d(29.15vw, 0, 0);
    transform: translate3d(29.15vw, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(100vw, 0, 0);
    transform: translate3d(100vw, 0, 0);
  }
}
.selected-bottom .reserve-3 {
  background: linear-gradient(90deg, #fd503e 0.55%, #ff4060 99.92%);
  overflow: hidden;
}
.selected-bottom .exp-reserve-1 {
  width: 100vw;
  height: 0.55rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.04rem;
  background: linear-gradient(90deg, rgba(253, 80, 62, 0.1) 0.55%, rgba(255, 64, 96, 0.1) 99.92%);
}
.selected-bottom .exp-reserve-1 .exp-reserve-icon-left {
  width: 0.16rem;
  height: 0.15rem;
  margin-left: 0.44rem;
}
.selected-bottom .exp-reserve-1 .exp-reserve-font {
  margin-left: 0.89vw;
  font-family: PingFang SC;
  font-size: 0.12rem;
  line-height: 1.06;
  letter-spacing: 0px;
  color: #ffffff;
}
.selected-bottom .exp-reserve-1 .exp-reserve-left {
  color: #fd4456;
  margin-left: 16px;
}
.selected-bottom .exp-box {
  position: relative;
}
.selected-bottom .exp-reserve-3 {
  width: 3.03rem;
  height: 0.47rem;
  line-height: 0.47rem;
  display: flex;
  background: linear-gradient(90deg, #fd503e 0.55%, #ff4060 99.92%);
  border-radius: 33px 33px 33px 33px;
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0.08rem;
  margin: 0.04rem 0;
}
.selected-bottom .exp-reserve-3 .exp-reserve-icon-right {
  width: 0.18rem;
  height: 0.18rem;
  margin-left: 0.48rem;
  position: relative;
  top: 0.15rem;
}
.selected-bottom .exp-reserve-3 .sweep-animation {
  visibility: hidden;
  position: absolute;
  width: 20.85vw;
  height: 16.34vw;
  z-index: 0;
  background-image: url("https://lvlin-base.cdn.bcebos.com/law/pages/images/btn-ani.png");
  background-size: contain;
  left: 0;
  -webkit-animation: rightSlide 1s linear;
  animation: rightSlide 1s linear;
  animation-delay: 5s;
  animation-fill-mode: forwards;
}
.selected-bottom .exp-reserve-3 .exp-reserve-font {
  margin-left: 0.07rem;
  font-family: PingFang SC;
  font-size: 0.18rem;
  font-weight: 500;
  letter-spacing: 0px;
  color: #ffffff;
}
.selected-bottom .message {
  flex: 1;
  height: 0.55rem;
  font-size: 0.18rem;
  color: #fff;
  position: relative;
  flex-shrink: 0;
  background-image: linear-gradient(90deg, #fd503e 1%, #ff4060 100%) !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 0.6px solid #eee;
}
.selected-bottom .message .message-icon {
  width: 22px;
  height: 22px;
  margin: 0 auto 2px auto;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/images/message-icon.png');
  background-size: contain;
  background-repeat: no-repeat;
}
.selected-bottom .message .small-font {
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  margin-top: 6px;
  font-family: PingFang SC;
}
.selected-bottom .for-consult-history-bubble [class*="__bubble-background"] {
  position: absolute;
  top: -38px;
  right: 0.17rem;
  border-radius: 20px;
}
.selected-bottom /deep/ [class*="bubble-background"] {
  position: absolute;
  top: -38px;
  right: 0.17rem;
  border-radius: 20px;
}
.compatible-safarea {
  padding-bottom: 0.39rem;
}
.reserve-font-4 {
  font-size: 13px !important;
}
.reserve-font-5 {
  font-size: 10.66px !important;
}

</style>
